import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import {
  FormAlert,
  FormGroup,
  NewInputText,
  parseFinalFormErrors,
} from '@saucelabs/sl-component-form';
import { Row, Col } from '@saucelabs/sl-component-grid';
import Button from '@saucelabs/sl-component-buttons';
import validate from '@saucelabs/sl-util-validate';
import { CURRENT_DC } from '@saucelabs/sl-util-config';

const constraints = {
  username: {
    presence: { allowEmpty: false },
  },
};

const SendPasswordResetForm = ({ sendPasswordReset }) => (
  <Form
    onSubmit={(values) => (
      sendPasswordReset({ ...values, data_center: CURRENT_DC })
        // react-final-form requires forms to resolve with no value on success
        .then(() => null)
        .catch(({ response }) => (
          parseFinalFormErrors(
            {},
            response.data.errors?.username || response.data.message,
          )
        ))
    )}
    render={({ form, handleSubmit }) => {
      const { error, submitError, submitting } = form.getState();

      return (
        <form onSubmit={handleSubmit}>
          <FormAlert type="danger">{error || submitError}</FormAlert>
          <Row>
            <Col xs>
              <Field
                autoFocus
                className="form-control"
                component={NewInputText}
                name="username"
                placeholder="Username or email address"
                type="text"
              />
            </Col>
          </Row>
          <FormGroup>
            <Button
              block
              category="action"
              disabled={submitting}
              type="submit"
            >
              Reset Password
            </Button>
          </FormGroup>
        </form>
      );
    }}
    validate={(values) => validate(values, constraints, { format: 'grouped' })}
  />
);

SendPasswordResetForm.propTypes = {
  sendPasswordReset: PropTypes.func.isRequired,
};

export default SendPasswordResetForm;
export { SendPasswordResetForm };
